import type { FC } from 'react';
import { Fragment, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';

import { Paper, Wrapper } from 'components/UI/Paper';

import { useDeviceWidth } from 'hooks/useDeviceWidth';

import { searchParamsNames } from 'constants/searchParamsNames';

import Browsers from './Browsers';
import GoBack from './GoBack';
import styles from './styles.module.scss';

const DevicePermissionDenied: FC = () => {
    const { isDesktop } = useDeviceWidth();
    const { triggerYM } = useYM();
    const WrapperComponent = isDesktop ? Wrapper : Fragment;
    const PaperComponent = isDesktop ? Paper : Fragment;
    const [search] = useSearchParams();
    const hasRedirectTo = search.has(searchParamsNames.redirectTo);

    useEffect(() => {
        triggerYM({ goal: GoalType.DEVICE_PERMISSION_DENIED_PAGE_VIEW });
    }, []);

    return (
        <div className={styles.devicePermissionPage}>
            {hasRedirectTo ? <GoBack /> : null}
            <WrapperComponent>
                <PaperComponent>
                    <Browsers />
                </PaperComponent>
            </WrapperComponent>
        </div>
    );
};

export default DevicePermissionDenied;
